import type { FeatureFlagsApi } from '@backstage/core-plugin-api';
import { ScaffolderClient } from '@backstage/plugin-scaffolder';
import type { ScaffolderApi } from '@backstage/plugin-scaffolder-react';
import type { HomesteadFeatureFlagName } from '../../homesteadFeatureFlags';

type ScaffolderClientOptions = ConstructorParameters<typeof ScaffolderClient>[0];

const STREAMING_LOGS_FLAG =
  'scaffolder-streaming-logs' satisfies HomesteadFeatureFlagName;

/**
 * ScaffolderClient that polls task logs over HTTP by default and streams them (SSE)
 * only while the `scaffolder-streaming-logs` feature flag is on.
 */
export class ToggleableScaffolderClient extends ScaffolderClient {
  private readonly pollingClient: ScaffolderClient;
  private readonly featureFlagsApi: FeatureFlagsApi;

  constructor({
    featureFlagsApi,
    ...options
  }: ScaffolderClientOptions & { featureFlagsApi: FeatureFlagsApi }) {
    super(options);
    this.featureFlagsApi = featureFlagsApi;
    this.pollingClient = new ScaffolderClient({
      ...options,
      useLongPollingLogs: true,
    });
  }

  override streamLogs(...args: Parameters<ScaffolderApi['streamLogs']>) {
    if (this.featureFlagsApi.isActive(STREAMING_LOGS_FLAG)) {
      return super.streamLogs(...args);
    }
    return this.pollingClient.streamLogs(...args);
  }
}
